import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { LOGO_URL, formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Connexion réussie");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="flex flex-col items-center mb-10">
          <img src={LOGO_URL} alt="Logo" className="h-16 w-16 object-contain mb-4" />
          <h1 className="font-display text-3xl text-white">Espace administrateur</h1>
          <p className="text-zinc-500 text-sm mt-2">La Fondation des Artistes</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="w-full bg-[#0d0d0d] border border-white/15 px-4 py-3 text-white focus:border-[#2563EB] outline-none"
          />
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            className="w-full bg-[#0d0d0d] border border-white/15 px-4 py-3 text-white focus:border-[#2563EB] outline-none"
          />
          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 bg-[#2563EB] hover:bg-[#1D4ED8] disabled:opacity-60 text-white px-10 py-3 text-sm tracking-wide transition-colors"
          >
            {loading && <Loader2 className="h-4 w-4 animate-spin" />} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
